module.exports = __webpack_public_path__ + "static/img/welcome_join_us_phone.ae166183.png";